import { z } from "zod";
const employeeStatusFilter = z.enum(["ACTIVE", "ON_LEAVE", "TERMINATED", "UNKNOWN"]);
const employeeSort = z.enum([
    "fullName:asc",
    "fullName:desc",
    "hireDate:asc",
    "hireDate:desc",
]);
function emptyToUndefined(value) {
    return value === undefined || value === "" ? undefined : value;
}
function normalizeListEmployeesQuery(raw) {
    if (!raw || typeof raw !== "object")
        return raw;
    const q = raw;
    const nested = q.filter && typeof q.filter === "object"
        ? q.filter
        : {};
    const filter = {
        status: emptyToUndefined(nested.status ?? q["filter[status]"]),
        companyId: emptyToUndefined(nested.companyId ?? q["filter[companyId]"]),
        departmentId: emptyToUndefined(nested.departmentId ?? q["filter[departmentId]"]),
        positionId: emptyToUndefined(nested.positionId ?? q["filter[positionId]"]),
        managerId: emptyToUndefined(nested.managerId ?? q["filter[managerId]"]),
        q: emptyToUndefined(nested.q ?? q["filter[q]"]),
    };
    const hasFilter = Object.values(filter).some((v) => v !== undefined);
    return {
        cursor: q.cursor,
        limit: q.limit,
        sort: q.sort,
        filter: hasFilter ? filter : undefined,
    };
}
/** Query de listagem — filtros + cursor (FASE-06-T25). */
export const listEmployeesQuerySchema = z.preprocess(normalizeListEmployeesQuery, z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    sort: employeeSort.default("fullName:asc"),
    filter: z
        .object({
        status: employeeStatusFilter.optional(),
        companyId: z.string().uuid().optional(),
        departmentId: z.string().uuid().optional(),
        positionId: z.string().uuid().optional(),
        managerId: z.string().uuid().optional(),
        /** Texto livre: nome, e-mail, matrícula. */
        q: z.string().trim().min(1).max(120).optional(),
    })
        .optional(),
}));
/** Filtros de UI sincronizados com a URL (subset do query). */
export const employeeDirectoryFiltersSchema = z.object({
    status: employeeStatusFilter.optional(),
    companyId: z.string().uuid().optional(),
    departmentId: z.string().uuid().optional(),
    positionId: z.string().uuid().optional(),
    managerId: z.string().uuid().optional(),
    q: z.string().trim().min(1).max(120).optional(),
    sort: employeeSort.default("fullName:asc"),
});
//# sourceMappingURL=list-employees-query.js.map